  // ingredients
  $('#ingredients .slider-text').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '#ingredients .slider',
    adaptiveHeight: true
});

$('#ingredients .slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '#ingredients .slider-text',
    fade: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 4000,
    // autoplaySpeed: 400,
    pauseOnDotsHover: true,
    prevArrow: '<a class="slick-prev" href="#"><img src="https://dtjlhiahlv53j.cloudfront.net/assets/drc/v01/arrow.svg"/></a>',
    nextArrow: '<a class="slick-next" href="#"><img src="https://dtjlhiahlv53j.cloudfront.net/assets/drc/v01/arrow.svg"/></a>',
    appendDots: $(".ingredients__nav"),
    customPaging: function (slick, index) {
        var targetImage = slick.$slides.eq(index).find('picture').attr('data-img');
        //   return '<img src=" ' + targetImage + ' "/>';
        return ' <picture><source media="(max-width: 767.98px)" srcset=" ' + targetImage + '_d.jpg"><source media="(min-width:768px)" srcset="' + targetImage + '_d.jpg"><img class="lazyload" data-src="' + targetImage + '_d.jpg" alt="comparing"></picture>'
    }

});